// extracted by mini-css-extract-plugin
module.exports = {"salary":"styles_salary__2DZyY"};